import { render, staticRenderFns } from "./closed-order.vue?vue&type=template&id=f57fe2d8&"
import script from "./closed-order.vue?vue&type=script&lang=js&"
export * from "./closed-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports